/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-divider/webhook-form-divider.component.scss */
:root {
  --divider-color: var(--tem-accent);
}
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
}
nz-divider::before,
nz-divider::after {
  border-color: var(--divider-color) !important;
}
/*# sourceMappingURL=webhook-form-divider.component.css.map */
